import { QueryBuilderModel } from 'vet-bones/components';
import {
  addDraftFields,
  getUsedVariables,
  updateValidation,
} from 'vet-bones/utils/queryBuilder';

import { ModelRule } from 'src/containers/ProjectDiagram/types/data';
import { getValidThenModel } from 'src/containers/ProjectDiagram/utils/rules/getValidThenModel';
import {
  IF_QUERY_BUILDER_SCHEMA,
  THEN_QUERY_BUILDER_SCHEMA,
} from 'src/containers/ProjectRuleDetailDrawer/constants';

export const isRuleValid = (
  rule: ModelRule,
  validModel: QueryBuilderModel
): boolean => {
  const { isValid: isIfValid, topExpression: ifValue } = updateValidation({
    copy: IF_QUERY_BUILDER_SCHEMA.copy,
    topExpression: addDraftFields(rule.ifClause.data.query),
    validModel,
  });

  if (!isIfValid) {
    return false;
  }

  const ifVariables = getUsedVariables(ifValue);
  const { isValid: isThenValid } = updateValidation({
    copy: THEN_QUERY_BUILDER_SCHEMA.copy,
    topExpression: addDraftFields(rule.thenClause.data.query),
    validModel: getValidThenModel(validModel),
    validVariables: ifVariables,
  });

  return isThenValid;
};
